import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-7"
}
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = {
  key: 0,
  class: "col-span-12 text-gray-600"
}
const _hoisted_5 = { class: "col-span-12" }
const _hoisted_6 = {
  key: 1,
  class: "col-span-12 text-red-600"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["innerHTML"]

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import ActivityLogsTable from '@/components/ActivityLogsTable.vue';
import SmartTags from '@/components/SmartTags.vue';
import CKEditor from '@/components/inputs/CKEditor.vue';

import EmailNotification from "@/classes/EmailNotification";

import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref, computed } from 'vue';

const smartTagsText = '<p>You may use the following smart tags to further customize the notification:</p><br/><ul><li>{{email_address}}</li><li>{{first_name}}</li><li>{{last_name}}</li></ul>';

export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();

// Data
const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)

const item = ref(null);

const payload = computed(() => {
    return {
        id: route.params.id,
        subject: null,
        greetings: null,
        body: null
    }
})

const currentRoutePath = computed(() => router.currentRoute.value.path);

const log_counts      = ref(0);
const logs            = ref({});

// Methods
const editEmailNotification = () => {
    loader.value = true;

    EmailNotification.editEmailNotification(route.params.id)
        .then((response: any) => {
            loader.value = false;

            item.value = response.data.emailNotification;
            payload.value.subject = item.value.subject;
            payload.value.greetings = item.value.greetings;
            payload.value.body = item.value.body;

            log_counts.value = response?.data.log_counts
            logs.value = response?.data.logs

        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const updateEmailNotification = () => {
    loader.value = true;

    EmailNotification.updateEmailNotification(route.params.id, payload.value)
        .then((response: any) => {
            loader.value = false;
            showSuccess.value = true;
            item.value = response.data.emailNotification;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 422) {
                errors.value = err.response.data.errors;
            }
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const tabs: { name: string, count: number, href?: string, allowed: boolean }[] = computed(() => [
    {
        name: 'Information',
        count: 0,
        href: `/contents/email-notification/edit/${route.params.id}`,
        allowed: true
    },
    {
        name: 'Activity logs',
        count: log_counts.value,
        href: `/contents/email-notification/edit/${route.params.id}/logs`,
        allowed: true
    },
]);

onMounted( () => {
    editEmailNotification();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Notification",
    "show-back": "",
    backUrl: "/contents/email-notification"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs.value }, null, 8, ["tabs"])
      ]),
      (currentRoutePath.value !== `/contents/email-notification/edit/${_unref(route).params.id}/logs`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(FormSection, null, {
              title: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode(" Notification Information ", -1)
              ]))]),
              description: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode(" Relevant data and other details ", -1)
              ]))]),
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(TextInput, {
                    label: "Subject",
                    placeholder: "Subject",
                    modelValue: payload.value.subject,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.subject) = $event)),
                    id: "subject",
                    name: "subject"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(TextInput, {
                    label: "Greetings",
                    placeholder: "Greetings",
                    modelValue: payload.value.greetings,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.greetings) = $event)),
                    id: "greetings",
                    name: "greetings"
                  }, null, 8, ["modelValue"])
                ]),
                (item.value?.greatings_smart_tags)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block text-sm" }, " Required smart tags for greetings: ", -1)),
                      _createElementVNode("p", null, _toDisplayString(item.value?.greatings_smart_tags.join(', ')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(CKEditor, {
                    label: "Body",
                    modelValue: payload.value.body,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.body) = $event)),
                    id: "body"
                  }, null, 8, ["modelValue"])
                ]),
                (item.value?.body_smart_tags)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm" }, " Required smart tags for body: ", -1)),
                      _createElementVNode("p", null, _toDisplayString(item.value?.body_smart_tags.join(', ')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              actions: _withCtx(() => [
                (_ctx.$hasPermission('update-content'))
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showConfirmation.value = true))
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode(" Save Changes ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(ActivityLogsTable, {
              logs: logs.value,
              onFetchIndex: editEmailNotification
            }, null, 8, ["logs"])
          ])),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", { innerHTML: errorMsg.value }, null, 8, _hoisted_8)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Confirm",
        title: "Email Notification Updated!",
        content: "Email Notification has been updated successfully"
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[8] || (_cache[8] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => {showConfirmation.value = false; updateEmailNotification() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Update Email Notification?",
        content: "Are you sure you wish to update this Email Notification?"
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})